export interface HighlightContentOptions {
  linkClassName?: string
  mentionClassName?: string
  hashtagClassName?: string
}

export const highlightContent = (
  text: string,
  { linkClassName, mentionClassName, hashtagClassName }: HighlightContentOptions,
) => {
  if (!text) return ''
  const linkRegex = /(https?:\/\/[^\s]+)/g
  const hashtagRegex = /(#\w+)/g
  const mentionRegex = /(@\w+)/g

  let highlightedText = text

  if (linkClassName) {
    highlightedText = highlightedText.replace(linkRegex, (match) => `<span class="${linkClassName}">${match}</span>`)
  }

  if (mentionClassName) {
    highlightedText = highlightedText.replace(
      mentionRegex,
      (match) => `<span class="${mentionClassName}">${match}</span>`,
    )
  }

  if (hashtagClassName) {
    highlightedText = highlightedText.replace(
      hashtagRegex,
      (match) => `<span class="${hashtagClassName}">${match}</span>`,
    )
  }

  return highlightedText
}
